import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import { auth } from '../../firebase';
import * as routes from '../../constants/routes';
import { PasswordForgetLink, SignUpLink } from './Links';


const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginLeft: theme.spacing.unit*6,
    marginRight: theme.spacing.unit*6,
    marginBottom: theme.spacing.unit*6,
  },
  passwordForget: {
    alignSelf: "flex-end",
    marginTop: theme.spacing.unit,
  },
  button: {
    marginTop: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
  },
  signUp: {
    marginTop: theme.spacing.unit,
    alignSelf: "center",
  }
});

class SignInForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.START);
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;
    const { classes } = this.props;

    const isInvalid = password === '' || email === '';

    return (
      <form className={classes.root} onSubmit={this.onSubmit}>
        <TextField
          label="Email"
          value={email}
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          margin="normal"
        />
        <TextField
          label="Password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={event => this.setState(byPropKey('password', event.target.value))}
          margin="normal"
        />
        <div className={classes.passwordForget}><PasswordForgetLink /></div>

        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          disabled={isInvalid}
          type="submit"
        >
          Sign In
        </Button>

        { error && <p>{error.message}</p> }

        <div className={classes.signUp}><SignUpLink /></div>
      </form>
    );
  }
}

export default withStyles(styles)(SignInForm);



// WEBPACK FOOTER //
// ./src/components/auth/SignInForm.jsx